var m = require('mithril');
var prop = require('mithril/stream');
var loaders = require('../../layout/components/loaders');
var Model = require('../../libs/Model');
var Point = require('./point');
var writeCommandEvents = require('../writeCommandEvents');
var writeOperations = require('../writeOperation');
var modal = require('../../layout/components/modal')
var button = require('../../components/button');
var pointCommands = require('../components/pointCommands');
var writeValueControl = require('../components/writeValueControl');
var mod = Object.create(Model);

mod.name = 'Point';
mod['@class'] = 'Point';
mod.url = 'point';
mod.fields = {
  value: {}
};

mod.vm = {};
mod.pointRecord = {};
var formGeneration = 0;
var saveActionGeneration = 0;

function normalizeRid(rid) {
  if (rid && typeof rid === 'object') {
    rid = rid['@rid'];
  }
  if (typeof rid !== 'string' || !rid) {
    return null;
  }
  return rid[0] === '#' ? rid.slice(1) : rid;
}

function writeError(message) {
  mod.errors = [message];
  m.redraw();
  return false;
}

mod.initForm = function (columnRecord, parentRid) {
  var generation = ++formGeneration;
  var requestedColumn = columnRecord;
  var requestedPoint = columnRecord && columnRecord.in;
  var requestedPointRid = requestedPoint &&
    (requestedPoint.writeAlternatePoint || requestedPoint['@rid']);

  mod.vm.column = columnRecord;
  mod.vm.parentRid = parentRid;
  mod.vm.formGeneration = generation;
  mod.vm.loading = true;
  mod.vm.activeTab = prop('command');
  mod.vm.defaultButtons = null;
  mod.vm.buttonsInitialized = false;
  mod.vm.writeOperations = {};
  mod.vm.path = [];
  mod.pointRecord = {};
  mod.sourcePointRecord = {};
  Model.initForm.call(mod, requestedPoint);
  if (requestedPoint) {
    mod.vm.column.pointWriteRid = requestedPointRid;
    return loaders.requestWithLoader({
      url: '/api/v1/point/' + requestedPointRid.slice(1),
      method: 'GET'
    })
    .then(pointRecord => {
      if (generation !== formGeneration) {
        return null;
      }
      var sourcePointRid = requestedPoint && requestedPoint['@rid'];
      var sourcePointRequest = sourcePointRid === pointRecord['@rid']
        ? Promise.resolve(pointRecord)
        : loaders.requestWithLoader({
          url: '/api/v1/point/' + sourcePointRid.slice(1),
          method: 'GET'
        });

      return sourcePointRequest.then(function (sourcePointRecord) {
        if (generation !== formGeneration) return null;
        mod.pointRecord = pointRecord;
        mod.sourcePointRecord = sourcePointRecord;
        // Ignore enumeration for boolean units
        if (pointRecord.unit === 'bool') {
          mod.form.value(Boolean(Number(pointRecord.value)));
        } else if (pointRecord.enumeration) {
          mod.pointRecord.enumeration = pointRecord.enumeration;
          mod.form.value(pointRecord.value);
        } else {
          mod.form.value(Point.readValue({
            value: parseFloat(pointRecord.value),
            unit: pointRecord.unit,
            destUnit: pointRecord.destUnit,
            displayUnit: pointRecord.displayUnit,
            scale: pointRecord.scale,
            offset: pointRecord.offset
          }));
          mod.vm.increment = Number(pointRecord.increment) || 1;
        }
        if (requestedColumn['@rid']) {
          return loaders.requestWithLoader({
            url: '/api/v1/column/' + requestedColumn['@rid'].slice(1),
            method: 'GET'
          });
        }
        return {
          name: requestedColumn.name || pointRecord.name,
          '@class': requestedColumn['@class'] || 'Column',
          path: Array.isArray(requestedColumn.path) ? requestedColumn.path : []
        };
      });
    })
    .then(columnRecord => {
      if (generation !== formGeneration) {
        return;
      }

      const basePath = Array.isArray(columnRecord.path) ? columnRecord.path.slice() : [];
      mod.vm.path = basePath.concat([{
        name: columnRecord.name,
        '@rid': columnRecord['@rid'],
        '@class': columnRecord['@class'],
      }]);
      mod.vm.loading = false;
      m.redraw();
    });
  } else {
    Model.initForm.call(mod, columnRecord);
    mod.vm.loading = false;
  }
};

mod.save = function () {
  var saveGeneration = ++saveActionGeneration;
  var saveFormGeneration = formGeneration;
  var confirmationLoaderStarted = false;
  var confirmationLoaderReleased = false;
  function isCurrentSave() {
    return saveGeneration === saveActionGeneration && saveFormGeneration === formGeneration;
  }
  function ensureCurrentSave() {
    if (isCurrentSave()) return;
    var error = new Error('A newer Point write replaced this save.');
    error.code = 'POINT_WRITE_SAVE_SUPERSEDED';
    throw error;
  }
  function startConfirmationLoader() {
    if (confirmationLoaderStarted) return;
    confirmationLoaderStarted = true;
    loaders.submit.start();
  }
  function releaseConfirmationLoader() {
    if (!confirmationLoaderStarted || confirmationLoaderReleased) return;
    confirmationLoaderReleased = true;
    loaders.submit.stop();
  }
  mod.errors = [];
  m.redraw();

  var pointRecord = mod.pointRecord;
  var columnRecord = mod.vm.column;
  var userValue = mod.form.value();
  let val;
  let parentRid = normalizeRid(mod.vm.parentRid);

  if (!pointRecord || !pointRecord['@rid']) {
    return writeError('Point write data is still loading. Try again in a moment.');
  }

  if (!parentRid) {
    return writeError('Cannot write point without a parent location or equipment context.');
  }

  var expectedPointConfiguration;
  try {
    expectedPointConfiguration = Point.expectedPointConfiguration([
      mod.sourcePointRecord,
      pointRecord
    ]);
  } catch (error) {
    return writeError(error.message);
  }

  if (userValue === undefined || userValue === null || userValue === '') {
    val = null;
  } else {
    val = Point.writeValue({
        scale: pointRecord.scale,
        unit: pointRecord.unit,
        destUnit: pointRecord.destUnit,
        displayUnit: pointRecord.displayUnit
      }, 
      userValue
    );
  }

  let url = '/api/v1/point/' + pointRecord['@rid'].slice(1) + '/write' + '/' + parentRid;
  let sourcePointRid = columnRecord && columnRecord.in && columnRecord.in['@rid'];
  if (!sourcePointRid) {
    return writeError('Cannot write point without a logical source point.');
  }
  var requestBody = {
    value: val,
    commandType: 'write',
    sourcePointRid: sourcePointRid,
    expectedPointConfiguration: expectedPointConfiguration
  };
  mod.vm.writeOperations = mod.vm.writeOperations || {};
  var writeOperation = null;

  return writeOperations.prepare(
    mod.vm.writeOperations,
    'write',
    url,
    requestBody,
    {
      scope: [sourcePointRid, parentRid, 'point-write'].join(':'),
      intent: {
        commandType: 'write',
        sourcePointRid: sourcePointRid,
        value: userValue
      },
      conflictScopes: [sourcePointRid, pointRecord['@rid']]
        .filter(function (rid, index, all) { return all.indexOf(rid) === index; })
        .map(function (rid) { return writeOperations.pointConflictScope(rid); }),
      conflictGroup: JSON.stringify({
        surface: 'point-write',
        sourcePointRid: sourcePointRid,
        parentRid: parentRid,
        value: userValue
      }),
      recoveryPolicy: writeOperations.ATTENDED_RECOVERY_POLICY
    }
  )
  .then(function (preparedOperation) {
    writeOperation = preparedOperation;
    if (!isCurrentSave()) return { superseded: true };
    return writeCommandEvents.waitForPointWrite({
    pointRid: writeOperations.pointRidForOperation(writeOperation),
    request: async function () {
      ensureCurrentSave();
      await writeOperations.markAttempted(writeOperation);
      ensureCurrentSave();
      return loaders.requestWithLoader({
        loader: 'submit',
        url: writeOperation.url,
        method: 'PUT',
        body: writeOperation.body
      });
    },
    onCommand: function () {
      ensureCurrentSave();
      // requestWithLoader stops after the queue response; keep the submit
      // indicator active until the matching worker acknowledgement arrives.
      startConfirmationLoader();
    },
    timeoutMessage: 'Timed out waiting for write confirmation.'
    });
  })
  .then(async function (completion) {
    if (completion && completion.superseded || !isCurrentSave()) {
      return { superseded: true };
    }
    await writeOperations.complete(mod.vm.writeOperations, 'write', writeOperation);
    if (!isCurrentSave()) return { superseded: true };

    var result = completion && completion.command || {};
    var user = result.user || {};
    var name = [user.firstName, user.lastName].filter(Boolean).join(' ') || 'unknown user';
    mod.successes.push('Successfully updated by ' + name + ' on ' + new Date());
    m.redraw();
    return completion;
  })
  .catch(async function (error) {
    if (!isCurrentSave() || error && error.code === 'POINT_WRITE_SAVE_SUPERSEDED') {
      return false;
    }
    if (error && error.writeApplied) {
      mod.successes.push('This exact write was already confirmed; no duplicate request was sent.');
      m.redraw();
      return { writeApplied: true };
    }
    if (writeOperation) {
      try {
        await writeOperations.fail(mod.vm.writeOperations, 'write', writeOperation, error);
      } catch (recoveryError) {
        error = recoveryError;
      }
    }
    if (!isCurrentSave()) {
      return false;
    }

    var message = error && (error.error || error.message) || String(error || 'Write failed');
    mod.errors.push('Failed update on ' + new Date() + ' with error: ' + message);
    m.redraw();
    return false;
  })
  .finally(function () {
    // Pair only the extra confirmation indicator started by this save. The
    // transport loader and any newer save retain their own independent count.
    releaseConfirmationLoader();
  });

};

mod.view = function  () {
  if (!mod.form) { return; }

  const breadcrumbPath = (mod.vm && (mod.vm.path || (mod.vm.column && mod.vm.column.path))) || [];
  const lastValidIdx = Array.isArray(breadcrumbPath) ? (breadcrumbPath.length - 1) : -1;

  if (!mod.vm.activeTab) {
    mod.vm.activeTab = prop('command');
  }

  const activeTab = mod.vm.activeTab();

  function ensureDefaultButtons() {
    if (!mod.vm.buttonsInitialized && typeof modal?.vm?.buttons === 'function') {
      mod.vm.defaultButtons = modal.vm.buttons().slice();
      mod.vm.buttonsInitialized = true;
    }
  }

  function applyModalButtons(tabKey) {
    if (typeof modal?.vm?.buttons !== 'function') { return; }
    ensureDefaultButtons();
    if (tabKey === 'history') {
      if ((modal.vm.buttons() || []).length !== 0) {
        modal.vm.buttons([]);
      }
    } else if (Array.isArray(mod.vm.defaultButtons) && (modal.vm.buttons() || []).length === 0) {
      modal.vm.buttons(mod.vm.defaultButtons.slice());
    }
  }

  ensureDefaultButtons();
  applyModalButtons(activeTab);

  function setActiveTab(tabKey) {
    mod.vm.activeTab(tabKey);
    applyModalButtons(tabKey);
  }

  function modeAction(label, iconClass, tabKey, testId) {
    function activate() {
      setActiveTab(tabKey);
    }

    return m('div.pointer.ba.bw1.flex.items-center.justify-center', {
      'data-testid': testId,
      role: 'button',
      tabindex: 0,
      style: {
        minHeight: '2.5rem',
        paddingLeft: '0.8rem',
        paddingRight: '0.9rem',
        fontSize: '0.95rem',
        color: '#ddd',
        borderColor: '#777',
        backgroundColor: 'transparent',
        boxSizing: 'border-box',
      },
      onclick: activate,
      onkeydown: function (ev) {
        if (ev.key === 'Enter' || ev.key === ' ') {
          ev.preventDefault();
          activate();
        }
      },
    }, [
      m('i.' + iconClass + '.mr2'),
      label
    ]);
  }

  function renderModeSwitch() {
    return m('div.flex.justify-end.mb3', [
      activeTab === 'history'
        ? modeAction('Back to Command', 'ion-chevron-left', 'command', 'write-modal-command-action')
        : modeAction('View History', 'ion-ios-clock-outline', 'history', 'write-modal-history-action')
    ]);
  }

  function renderCommandTab() {
    if (!mod.pointRecord || !mod.pointRecord['@rid']) {
      return m('div.tc.pa2', 'Loading command form...');
    }

    const controlClusterWidth = '34rem';
    const controlLabelWidth = '6rem';
    const labelStyle = {
      display: 'inline-block',
      textAlign: 'right',
      marginRight: '0.75rem',
      fontSize: '1rem',
      alignSelf: 'center',
      flex: '0 0 ' + controlLabelWidth,
      width: controlLabelWidth,
      minWidth: controlLabelWidth,
      maxWidth: controlLabelWidth,
      boxSizing: 'border-box',
    };

    return m('div.mt4.flex.justify-start', [
      m('div.flex.items-center', {
        style: {
          width: '100%',
          maxWidth: controlClusterWidth,
        },
      }, [
        m('span.f2', { style: labelStyle }, 'Value'),
        m('div', { style: { flex: '1 1 auto', minWidth: 0 } }, [
          m(writeValueControl, {
            pointRecord: mod.pointRecord,
            value: mod.form.value(),
            increment: mod.vm.increment,
            fillWidth: true,
            onchange: function (value) {
              mod.form.value(value);
            }
          })
        ])
      ])
    ]);
  }

  function renderHistoryTab() {
    if (!mod.pointRecord || !mod.pointRecord['@rid']) {
      return m('div.tc.pa2', 'Loading history...');
    }

    return m('div.mt3', [
      m(pointCommands, {
        pointRid: mod.pointRecord['@rid'],
        pageSize: 10,
        pointUnit: mod.pointRecord && mod.pointRecord.unit,
        dragContainerStyle: { marginRight: '0px' },
      })
    ]);
  }

  return [
    mod.errorView(),
    mod.successView(),
    m('div.page-header.flex.justify-between.items-end', [
      m('div.flex.flex-wrap', {style: {'max-width': '88%'}}, [
        (breadcrumbPath || []).map(function (ancestor, idx) {
          var isLast = idx === lastValidIdx;
          if (ancestor.name === 'root') {
            return m('div');
          } else if (ancestor['@class'] == 'Element' || ancestor['@class'] == 'Dataset' || ancestor['@class'] == 'Column') {
            if (ancestor.url) {
              return m('div.mr2.nowrap.truncate', [
                m('a', {
                  href: ancestor.url,
                  onclick: function () {
                    modal.vm.close();
                  },
                }, ancestor.name),
                !isLast && m('span', ' - ')
              ]);
            } else {
              return m('div.mr2.nowrap.truncate', [
                ancestor.name,
                !isLast && m('span', ' - '),
              ]);
            }
          } else if (ancestor['@class'] == 'Site' || ancestor['@class'] == 'Building' || ancestor['@class'] == 'Level' || ancestor['@class'] == 'Room' ) {
            return m('div.mr2.nowrap.truncate',[
              m(m.route.Link, {
                href: `/location/${ancestor['@rid'].slice(1)}${m.route.get().split('?')[1] ? `?${m.route.get().split('?')[1]}`:''}`,
                onclick: function () {
                  modal.vm.close();
                },
              }, ancestor['@class'] == 'Room' ? 
                  `${ancestor.name} ${ancestor.roomNumber}` 
                : 
                  ancestor.name
              ),
              !isLast && ' / '
            ]);
          } else if (ancestor['@class'] == 'Dashboard') {
            return m('div.mr2.nowrap.truncate',[
              m(m.route.Link, {
                href: '/dashboard/' + ancestor['@rid'].slice(1),
                onclick: function () {
                  modal.vm.close();
                },
              }, ancestor.name || ancestor['@class']),
              !isLast && ' / '
            ]);
          } else {
            var href = '/equipment/'+ancestor['@class'].toLowerCase()+'/' + ancestor['@rid'].slice(1);
            var currentPath = (m.route.get() || '').split('?')[0];
            var isCurrent = currentPath === href;
            return m('div.mr2.nowrap.truncate', [
              isCurrent
                ? (ancestor.name || ancestor['@class'])
                : m(m.route.Link, {
                    href,
                    onclick: function () {
                      modal.vm.close();
                    },
                  }, ancestor.name || ancestor['@class']),
              !isLast && ' / '
            ]);
          }
        })
      ]),
      m(button, {
        class: 'dib ml3 point-detail-modal-link',
        showFeedback: false,
        style: {
          minWidth: '2.1rem',
          paddingTop: '0.05rem',
          paddingBottom: '0.12rem',
          paddingLeft: '0.3rem',
          paddingRight: '0.3rem',
          lineHeight: '1'
        },
        label: m('i.icon.ion-ios-gear.blue', {
          style: {
            'font-size': '1.5rem'
          }
        }),
        func: function () {
          if (mod.pointRecord && mod.pointRecord['@rid']) {
            m.route.set(
              '/point/' + String(mod.pointRecord['@rid']).slice(1),
              { column: mod.vm.column['@rid'] }
            );
          }
          modal.vm.close();
        }
      })
    ]),
    renderModeSwitch(),
    activeTab === 'command' ? renderCommandTab() : renderHistoryTab()
  ];
};

module.exports = mod;
